export default __webpack_public_path__ + "static/media/master-5.cfaf81dc.png";